import React from "react";
import { Line } from "react-chartjs-2";
import moment from "moment-timezone";

const viewType = (period)=>{
	if (period.length < 2) return "day";
	const diff = period[1].diff(period[0], "days");

	if (diff < 30) {
		return "day";
	} else if (diff < 90) {
		return "week";
	} else {
		return "month";
	}
};

const SmallLine = props => {
	const data = props.data || {};
	const datasets = data.datasets || {};
	const datasetsData = datasets.data || [];
	const minY = Math.min(...datasetsData) || 0;
	const suggestedMinY = Math.max(0, minY * 0.9);
	// console.log("smallline", data.datasets);
	// const maxValue = Math.max(...data.datasets[0].data);
	// const minValue = Math.min(...data.datasets[0].data);
	// const lengthData = data.datasets[0].data.length;
	// const dataToDisplay = data.datasets[0].data.slice(0, 4);
	// data.datasets[0].data = dataToDisplay;
	return (
		<div
			style={{
				height: props.height,
				width: props.width,
				position: "relative",
			}}
		>
			<Line
				data={data}
				legend={{ display: false }}
				options={{
					plugins: {
						datalabels: false,
					},
					layout: {
						padding: {
							right: 10,
							bottom: 10,
							top: 10,
						},
					},
					animation: {
						duration: 4000, // general animation time
					},
					tooltips: {
						callbacks: {
							title: function(tooltipItem=[]) {
								tooltipItem[0] = tooltipItem[0] || {};
								const label = tooltipItem[0].xLabel;
								const vt = viewType(props.period) !== "month" ? "D MMM" : "MMM";
								return moment(label).format(vt);
							}
						}
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									drawOnChartArea: false,
									drawBorder: false,
									display: false,
								},
								ticks: {
									display: false,
									autoSkip: false
								},
							},
						],
						yAxes: [
							{
								gridLines: {
									drawOnChartArea: false,
									drawBorder: false,
									display: false,
								},
								ticks: {
									min: props.min * 0.9,
									max: props.max * 1.1,
									//stepSize: 1,
									//suggestedMin: props.min * 0.9,
									//suggestedMax: props.max * 1.1,
									display: false,
									// max: maxValue,
									// min: minValue,
								},
							},
						],
					},

					maintainAspectRatio: false,
				}}
			/>
		</div>
	);
};

export default SmallLine;



// WEBPACK FOOTER //
// src/modules/stats/components/GraphViews/SmallLine.js